import { useState } from "react";
import { createContainer } from "unstated-next";

interface RoomsDots {
  [key: string]: number;
}

const useDotsContainer = () => {
  const [roomsWithDots, setRoomsWithDots] = useState<RoomsDots>({});

  const updateRoomDots = (
    roomID: string,
    value: number | ((n: number) => number) = 0
  ): number => {
    if (!roomID) return 0;
    const result =
      typeof value === "function" ? value(roomsWithDots[roomID] || 0) : value;
    setRoomsWithDots((c) =>
      c[roomID] === result ? c : { ...c, [roomID]: result }
    );
    return result;
  };

  const incrementRoomDots = (roomID: string): number =>
    updateRoomDots(roomID, (n) => n + 1);
  const clearRoomDots = (roomID: string): number => updateRoomDots(roomID, 0);
  const getRoomDots = (roomID: string): number => roomsWithDots[roomID] || 0;

  return {
    roomsWithDots,
    getRoomDots,
    setRoomsWithDots,
    updateRoomDots,
    incrementRoomDots,
    clearRoomDots,
  };
};

export const { useContainer: useChatDots, Provider: ChatDotsProvider } =
  createContainer(useDotsContainer);
